import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { AzureMLLinkedService } from 'app/model/linkedservice/azure-ml.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureMLLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                mlEndpoint: '*',
                apiKey: 'secret',
                updateResourceEndpoint: '*',
                servicePrincipalId: '*',
                servicePrincipalKey: 'secret',
                tenant: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class AzureMLLinkedServiceAdapter extends LinkedServiceAdapter<AzureMLLinkedService> {
    protected modelConstructor(): new () => AzureMLLinkedService {
        return AzureMLLinkedService;
    }

    protected model(): IModel {
        return AzureMLLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AzureMLLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AzureMLLinkedService;

        properties.type = Metamodel.modelFor(AzureMLLinkedService).name;

        let updateResourceEndpoint: string;
        let servicePrincipalId: string;
        let servicePrincipalKey: Model.SecretBase;
        let tenant: string;
        if (linkedService.enableUpdateResourceEndpoint) {
            updateResourceEndpoint = linkedService.updateResourceEndpoint;
            if (linkedService.useARMWebService) {
                servicePrincipalId = linkedService.servicePrincipalId;
                servicePrincipalKey = passwordOrAKVtoSecretBase(linkedService.servicePrincipalKey, this.context);
                tenant = linkedService.tenant;
            }
        }
        properties.typeProperties = {
            mlEndpoint: linkedService.mlEndpoint,
            apiKey: passwordOrAKVtoSecretBase(linkedService.apiKey, this.context),
            updateResourceEndpoint,
            servicePrincipalId,
            servicePrincipalKey,
            tenant
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AzureMLLinkedService): Promise<AzureMLLinkedService> {
        const properties = linkedServiceResource.properties as Model.AzureMLLinkedService;
        linkedService.mlEndpoint = properties.typeProperties.mlEndpoint;
        linkedService.apiKey = secretBaseToPasswordOrAKV(properties.typeProperties.apiKey, true, this.context);
        if (properties.typeProperties.updateResourceEndpoint) {
            linkedService.updateResourceEndpoint = properties.typeProperties.updateResourceEndpoint;
            if (properties.typeProperties.servicePrincipalId) {
                linkedService.servicePrincipalId = properties.typeProperties.servicePrincipalId;
                linkedService.servicePrincipalKey = secretBaseToPasswordOrAKV(properties.typeProperties.servicePrincipalKey, properties.typeProperties.servicePrincipalId, this.context);
                linkedService.tenant = properties.typeProperties.tenant;
                linkedService.useARMWebService = true;
            } else {
                linkedService.useARMWebService = false;
            }
            linkedService.enableUpdateResourceEndpoint = true;
        } else {
            linkedService.enableUpdateResourceEndpoint = false;
        }
        return linkedService;
    }
}
